export const UPDATE_COLUMN_CONFIG_SUCCESS = 'UPDATE_COLUMN_CONFIG_SUCCESS';

export const updateColumnConfigSuccess = (tableEntry) => ({
    type: UPDATE_COLUMN_CONFIG_SUCCESS,
    payload: { tableEntry },
});
